const overlay = {
  background: 'transparent'
};

const expenseModalStyles = {
  overlay,
  modal: {
    borderRadius: '0.75rem',
    marginTop: '170px',
    position: 'relative',
    float: 'right',
    right: '10px',
    width: 'auto'
  }
};
const POModalStyles = {
  overlay,
  modal: {
    borderRadius: '0.75rem',
    marginTop: '170px',
    float: 'right'
  }
};

const deleteModalStyles = {
  overlay,
  modal: {
    borderRadius: '0.75rem'
  }
};

const approveModalStyles = {
  modal: {
    borderRadius: '0.75rem',
    width: '600px'
  }
};

const createModalStyles = {
  modal: {
    borderRadius: '0.75rem',
    width: '540px'
  }
};
const mailModalStyles = {
  modal: {
    borderRadius: '0.75rem',
    height: 'fit-content',
    width: '700px'
  }
};
const ppeAddModalStyles = {
  modal: {
    borderRadius: '0.75rem',
    height: 'fit-content',
    width: '500px',
    float: 'center'
  }
};
const ppeComponentModalStyles = {
  modal: {
    borderRadius: '0.75rem',
    height: 'fit-content',
    width: '800px',
    float: 'center'
  }
};

export { ppeComponentModalStyles, ppeAddModalStyles, mailModalStyles, expenseModalStyles,
  POModalStyles, createModalStyles, deleteModalStyles, approveModalStyles };
